const getDefaultTitle = (type) => {
  switch (type) {
    case 'Curiosity':
      return 'Curiosity Corner';
    case 'Practice':
      return 'Quick Practice';
    case 'Watch':
      return 'Learn & Discover';
    case 'Video':
      return '';
    case 'Explore':
      return 'Explore Interactive';
    case 'BasicConcepts':
      return 'Basic Concepts';
    default:
      return `${type} Activity`;
  }
};

const getDefaultDescription = (type) => {
  switch (type) {
    case 'Curiosity':
      return 'Discover fascinating questions and real-life connections about this topic.';
    case 'Practice':
      return 'Test yourself on this page\'s content.';
    case 'Watch':
      return 'Explore interactive content and discover new insights about this topic.';
    case 'Video':
      return 'Watch an educational video related to this content.';
    case 'Explore':
      return 'Match each part with its description in this interactive game!';
    case 'BasicConcepts':
      return 'Learn foundational concepts with real-world examples.';
    default:
      return `Complete this ${type.toLowerCase()} activity.`;
  }
};

const formatDuration = (seconds, durationStr) => {
  if (seconds && typeof seconds === 'number') {
    const minutes = Math.ceil(seconds / 60);
    return `${Math.max(minutes, 1)} min`;
  }

  if (durationStr && typeof durationStr === 'string') {
    if (durationStr.includes(':')) {
      const parts = durationStr.split(':').map(Number);
      let totalSeconds = 0;
      if (parts.length === 3) {
        totalSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
      } else if (parts.length === 2) {
        totalSeconds = parts[0] * 60 + parts[1];
      }

      if (totalSeconds > 0) {
        const minutes = Math.ceil(totalSeconds / 60);
        return `${Math.max(minutes, 1)} min`;
      }
    }

    if (durationStr.trim().length > 0) return durationStr;
  }

  return null;
};

const getDefaultDuration = (type) => {
  switch (type) {
    case 'Curiosity':
      return '2 min';
    case 'Practice':
      return '5 min';
    case 'Watch':
      return '10 min';
    case 'Video':
      return '10 min';
    case 'Explore':
      return '5 min';
    case 'BasicConcepts':
      return '15 min';
    default:
      return '5 min';
  }
};

const getBaseRewards = (type) => {
  const rewards = {
    Watch: { xp: 5, gems: 0 },
    Video: { xp: 5, gems: 0 },
    Explore: { xp: 3, gems: 0 },
    Practice: { xp: 5, gems: 0 },
    Curiosity: { xp: 3, gems: 0 },
    BasicConcepts: { xp: 10, gems: 0 },
  };
  return rewards[type] || { xp: 5, gems: 0 };
};

export const buildActivityItem = (ann) => {
  const baseRewards = getBaseRewards(ann.annotation_type);

  const rawTitle = typeof ann.title === 'string' ? ann.title.trim() : '';
  const resolvedTitle = (ann.annotation_type === 'Video' && rawTitle === 'Watch Video') ? '' : rawTitle;

  return {
    id: ann.id,
    annotation_id: ann.id,
    type: ann.annotation_type,
    icon: ann.icon_type,
    duration: formatDuration(ann.duration_seconds, ann.duration) || getDefaultDuration(ann.annotation_type),
    section_name: ann.section_name,
    section_number: ann.section_number,
    one_liner: ann.one_liner,
    title: resolvedTitle || getDefaultTitle(ann.annotation_type),
    description: resolvedTitle
      ? (ann.annotation_type === 'Curiosity'
        ? `Explore fascinating questions about ${resolvedTitle}`
        : ann.annotation_type === 'Practice'
          ? `Practice questions for ${resolvedTitle}`
          : ann.annotation_type === 'Explore'
            ? `Match parts with descriptions: ${resolvedTitle}`
            : ann.annotation_type === 'BasicConcepts'
              ? `Learn foundational concepts: ${resolvedTitle}`
              : `${ann.annotation_type} activity: ${resolvedTitle}`)
      : getDefaultDescription(ann.annotation_type),
    video_file_url: ann.video_file_url || undefined,
    youtube_url: ann.youtube_url || undefined,
    chapter_id: ann.chapter?.id || ann.chapter,
    xpReward: baseRewards.xp,
    gemsReward: baseRewards.gems,
  };
};
